export type SubCategoryProps = {
	id: string;
	name: string;
};

export const SubCategory = [
	{ id: "1", name: "Trator" },
	{ id: "2", name: "Helicóptero" },
	{ id: "3", name: "Semirreboque" },
	{ id: "4", name: "Carroceria" },
	{ id: "5", name: "Caminhões e Ônibus" },
	{ id: "6", name: "Colheitadeira" },
	{ id: "7", name: "Leves (0km)" },
] as SubCategoryProps[];
